/** Message catalogue for features/catalog/data (merged into the global catalogues). Keys: "dat.<area>.<name>". */
import { comEn, comHi } from './commonMessages';
import { autEn, autHi } from './authorities/messages';
import { expEn, expHi } from './export/messages';
import { impEn, impHi } from './import/messages';

export const datEn = { ...comEn, ...impEn, ...expEn, ...autEn } as const;

export const datHi: Record<keyof typeof datEn, string> = { ...comHi, ...impHi, ...expHi, ...autHi };
